var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIsometric3 = function SvgIsometric3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1696 370"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4346F7",
    d: "M1696 0h-220v82h220z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0509F8",
    d: "M1476 0 220 288v82L1476 82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0205B5",
    d: "M220 288H0v82h220z"
  })));
};
export default SvgIsometric3;